/**
 * @generated SignedSource<<b78d22c9e592c9e05ed57eda564e3ad6>>
 * @relayHash 15a4ac41381a9cebf9cc7aae4b88bb8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ed5ea9a5ffa049456cdb5d199e780d42d8cf73d774b3996ff80b704bcc89419

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraRankNavigationItemInput = {
  afterItemId?: string | null | undefined;
  beforeItemId?: string | null | undefined;
  id: string;
  scopeId?: string | null | undefined;
};
export type useRankNavigationItemMutation$variables = {
  first: number;
  input: JiraRankNavigationItemInput;
};
export type useRankNavigationItemMutation$data = {
  readonly jira: {
    readonly rankNavigationItem: {
      readonly containerNavigation: {
        readonly __typename: "QueryError";
        readonly extensions?: ReadonlyArray<{
          readonly statusCode: number | null | undefined;
        }> | null | undefined;
        readonly id?: string;
        readonly message?: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"ContainerNavigationTabs_container">;
      } | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useRankNavigationItemMutation = {
  response: useRankNavigationItemMutation$data;
  variables: useRankNavigationItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "url"
},
v11 = {
  "kind": "ScalarField",
  "name": "label"
},
v12 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v13 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useRankNavigationItemMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraRankNavigationItemPayload",
            "kind": "LinkedField",
            "name": "rankNavigationItem",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "containerNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ContainerNavigationTabs_container"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "JiraContainerNavigation"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useRankNavigationItemMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraRankNavigationItemPayload",
            "kind": "LinkedField",
            "name": "rankNavigationItem",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "containerNavigation",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraContainerNavigationResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "scopeId"
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                          }
                        ],
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "navigationItems",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraNavigationItemEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                  },
                                  (v10/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                  },
                                  (v11/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraNavigationItem"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canRename"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canRemove"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canSetAsDefault"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "appId"
                                      },
                                      {
                                        "concreteType": "JiraAppSection",
                                        "kind": "LinkedField",
                                        "name": "sections",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": true,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              (v13/*: any*/)
                                            ]
                                          },
                                          (v11/*: any*/)
                                        ]
                                      },
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "envLabel"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/)
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                      }
                                    ],
                                    "type": "JiraAppNavigationItem"
                                  },
                                  (v14/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canEdit"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "scopeUrl"
                      }
                    ],
                    "type": "JiraContainerNavigation"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ],
                    "type": "QueryError"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3ed5ea9a5ffa049456cdb5d199e780d42d8cf73d774b3996ff80b704bcc89419",
    "metadata": {},
    "name": "useRankNavigationItemMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b874f134028fecbbc940964bd77f8cfc";

export default node;
